import { middleofficeRequest } from '../axios'
import useAuthExtranet from './useAuthExtranet'
const useLogout = () => {
  const { setAuth } = useAuthExtranet()
  const logout = async () => {
    setAuth({})
    try {
      await middleofficeRequest.post('middleoffice/auth/logout')
    } catch (error) {
      console.error({ error })
    }
  }
  return logout
}
export default useLogout
